import { createIdentifier } from '@toeverything/infra';

export interface AuthProvider {
  signInMagicLink(
    email: string,
    token: string,
    clientNonce?: string
  ): Promise<void>;

  signInOauth(
    code: string,
    platform: string
  ): Promise<{ code?: number | undefined; data?: any }>;

  signInPassword(credential: {
    email: string;
    password: string;
    verifyToken?: string;
    challenge?: string;
  }): Promise<void>;

  signOut(userId: string | number, token: string): Promise<void>;
  destoryAccount(userId: string | number, token: string): Promise<void>;
  getAuthInfoInServerSideV2(): Promise<{
    auth: any;
    isLogin: boolean;
    isRealLogin: boolean;
  }>;
  setUserAvatar(avatar: any): Promise<any>;
  setUserInfo({ key, value }: { key: string; value: any }): Promise<any>;
  checkUserHasRegistered(
    token: string
  ): Promise<{ code?: number | undefined; data?: any }>;
  signInOauthInvite(
    inviteCode: string,
    localStorageKey: string
  ): Promise<{ code?: number | undefined; data?: any }>;
  getLoginCode(
    email: string
  ): Promise<{ code?: number | undefined; data?: any }>;
  signInEmail({
    email,
    code,
  }: {
    email: string;
    code: string;
  }): Promise<{ code?: number | undefined; data?: any }>;
}

export const AuthProvider = createIdentifier<AuthProvider>('AuthProvider');
